import(/* webpackMode: "eager" */ "/app/app/loading.tsx");
